import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";
import { API } from "./api";

const PortalCtx = createContext(null);
const KEY = "alpha_portal_token";

const portalApi = axios.create({ baseURL: API, headers: { "Content-Type": "application/json" } });
portalApi.interceptors.request.use((config) => {
  const t = localStorage.getItem(KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

export function PortalAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = async () => {
    const t = localStorage.getItem(KEY);
    if (!t) {
      setUser(null);
      setLoading(false);
      return;
    }
    try {
      const { data } = await portalApi.get("/portal/me");
      setUser(data);
    } catch {
      localStorage.removeItem(KEY);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refresh();
  }, []);

  const login = async (email, password) => {
    const { data } = await portalApi.post("/portal/login", { email, password });
    localStorage.setItem(KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const register = async (payload) => {
    const { data } = await portalApi.post("/portal/register", payload);
    localStorage.setItem(KEY, data.access_token);
    setUser(data.user);
    return data.user;
  };

  const logout = () => {
    localStorage.removeItem(KEY);
    setUser(null);
  };

  return (
    <PortalCtx.Provider value={{ user, loading, login, register, logout, refresh, portalApi }}>
      {children}
    </PortalCtx.Provider>
  );
}

export function usePortal() {
  const ctx = useContext(PortalCtx);
  if (!ctx) throw new Error("usePortal must be used within PortalAuthProvider");
  return ctx;
}
